/**
 * アクティベート（招待）
 */
 import * as httpConst from '../../../constants/httpConst'
 import Vue from 'vue'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/activate`

 const activate = {
  namespaced: true,
  actions: {
    edit ({ commit }, { token }) {
      const api_path = `${API_PATH}/${token}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ token, params }) {
      const api_path = `${API_PATH}/${token}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params, { headers: { 'Content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
   },
  }

 export default activate